// Browse by tense: which Compare ideas teach each tense or mood.
// An idea can appear under more than one tense.
export const COMPARE_TENSES = [
    {
        id: 'present',
        label: { en: 'Present', it: 'Presente', es: 'Presente', fr: 'Présent', pt: 'Presente' },
        ideas: ['habits', 'now', 'there-is', 'liking', 'deduction'],
    },
    {
        id: 'past',
        label: { en: 'Past', it: 'Passato', es: 'Pasado', fr: 'Passé', pt: 'Passado' },
        ideas: ['past-finished', 'past-ongoing', 'past-connected', 'reported', 'time-expressions'],
    },
    {
        id: 'perfect',
        label: { en: 'Perfect tenses', it: 'Tempi composti', es: 'Tiempos perfectos', fr: 'Temps composés', pt: 'Tempos compostos' },
        ideas: ['perfect-tenses', 'past-connected', 'already-yet'],
    },
    {
        id: 'future',
        label: { en: 'Future', it: 'Futuro', es: 'Futuro', fr: 'Futur', pt: 'Futuro' },
        ideas: ['future', 'perfect-tenses', 'if'],
    },
    {
        id: 'conditional',
        label: { en: 'Conditional', it: 'Condizionale', es: 'Condicional', fr: 'Conditionnel', pt: 'Condicional' },
        ideas: ['would', 'if', 'wishes'],
    },
    {
        id: 'subjunctive',
        label: { en: 'Subjunctive', it: 'Congiuntivo', es: 'Subjuntivo', fr: 'Subjonctif', pt: 'Subjuntivo' },
        ideas: ['subjunctive', 'if', 'wishes', 'deduction'],
    },
    {
        id: 'imperative',
        label: { en: 'Commands', it: 'Imperativo', es: 'Imperativo', fr: 'Impératif', pt: 'Imperativo' },
        ideas: ['commands', 'combined-pronouns'],
    },
];